import { navigate } from 'gatsby-link'

import resolvePath from '../envs/resolvePath'

const goTo = (next_step, body = {}) => {
  return navigate(resolvePath(next_step), { state: body })
}

export default goTo
